// Copyright (c) 2021 WiseTime. All rights reserved.

import { concat, Observable, of } from "rxjs"
import { Action } from "redux"
import { catchError, filter, map, mergeMap } from "rxjs/operators"
import * as Actions from "../actions"
import * as Slice from "../slice"
import {
  SearchActivityTypesRequest,
  SearchActivityTypesResponse
} from "generated/legebill/site/activitytype/v4/activity_type_pb"
import { grpc } from "app/rpc/executor"
import { activityTypeServiceClient } from "app/rpc/client"
import { t } from "@lingui/macro"
import { showSnackBar } from "../../snackbar/actions"

type SearchActivityTypesRpc = (request: SearchActivityTypesRequest) => Observable<SearchActivityTypesResponse>

export const searchActivityTypes = (searchActivityTypesRpc: SearchActivityTypesRpc) =>
  (action$: Observable<Action>): Observable<Action> =>
    action$.pipe(
      filter(Actions.searchActivityTypes.match),
      mergeMap(action => of(action.payload)
        .pipe(
          mergeMap(searchActivityTypesRpc),
          map(t => t.toObject()),
          map(response => Slice.setResultActivityTypes({ searchString: action.payload.getSearchText(), response })),
          catchError(_ => concat(
            of(Slice.resetResultActivityTypes()),
            of(showSnackBar({
              message: t({
                id: "msg_search_activity_types_failed",
                message: "Failed to search for activity types. Please try again in a couple of minutes. If the error persists, please contact support@wisetime.com."
              }),
              messageType: "ERROR",
            })))),
        )
      ),
    )

const searchActivityTypesRpc = (request: SearchActivityTypesRequest): Observable<SearchActivityTypesResponse> =>
  grpc(() => activityTypeServiceClient.searchActivityTypes(request, null))

export default searchActivityTypes(searchActivityTypesRpc)
